import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CreditAgreementSectionWipContainer } from 'capitalProvider/domains/credit-agreements/ui/CreditAgreementWip';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import 'source/borrower/borrower.scss';

export const AdvanceRatesRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { creditFacilityId } = useCreditFacilityContext();

  let routeLevelError = false;
  return (
    <Box>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load advance rates page`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <CreditAgreementSectionWipContainer
          creditFacilityId={creditFacilityId}
          section="borrowingBaseMechanics"
        />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
